import { Box, Button } from '@mui/material';
import React from 'react'
import { LineChart } from '@mui/x-charts';
// import './lineSensori.scss'

const LineGraph = ({ subTrasporto }) => {
    const dataset = [
        { time: "13:00", temperatura: 40, umidita: 5, pressione: 20 },
        { time: "13:20", temperatura: 42, umidita: 18, pressione: 38 },
        { time: "13:40", temperatura: 45, umidita: 30, pressione: 60 },
        { time: "14:00", temperatura: 55, umidita: 38, pressione: 70 },
        { time: "14:20", temperatura: 65, umidita: 40, pressione: 75 },
        { time: "14:40", temperatura: 70, umidita: 42, pressione: 78 },
        { time: "15:00", temperatura: 72, umidita: 43, pressione: 79 },
        { time: "15:20", temperatura: 78, umidita: 42, pressione: 78 },
        { time: "15:40", temperatura: 82, umidita: 38, pressione: 76 },
        { time: "16:00", temperatura: 85, umidita: 30, pressione: 70 },
        { time: "16:20", temperatura: 80, umidita: 42, pressione: 65 },
        { time: "16:40", temperatura: 72, umidita: 48, pressione: 58 }
    ];

    const series = [
        {
            dataKey: "temperatura",
            color: "#57C700",
            showMark: true,
        },
        {
            dataKey: "umidita",
            color: "#90DDEC",
            showMark: true,
        },
        {
            dataKey: "pressione",
            color: "#225CA6",
            showMark: true,
        },
    ];
    const dataFilter = [
        {
            id: "temperatura",
            label: "Temperatura",
            color: "#4CAF50",
            action: "Temperatura",
        },
        {
            id: "umidita",
            label: "Umidità",
            color: "#90DDEC",
            action: "Umidita",
        },
        {
            id: "pressione",
            label: "Pressione",
            color: "#225CA6",
            action: "Pressione",
        },
    ];
    return (
        <>
            <Box className="graphLine">

                {/* Metrics Section */}
                <Box className="graphcard__body">
                    <Box display={'flex'} gap={"27px"} alignItems={"center"}>
                        <>
                            {dataFilter &&
                                dataFilter?.map((item) => (
                                    <Box key={item.id} display={'flex'} gap={"8px"} alignItems={"center"}
                                        style={{
                                            color: item.color,
                                            cursor: "pointer",
                                            textDecoration: "none"
                                        }}

                                    >
                                        <span
                                            style={{
                                                width: 12,
                                                height: 12,
                                                borderRadius: "50%",
                                                background: item.color,
                                                display: "inline-block",
                                            }}
                                        />
                                        {item.label}
                                    </Box>
                                ))}
                        </>
                    </Box>

                    {/* Chart */}
                    <Box style={{ display: "flex" }}>
                        <LineChart
                            className="MuiChartsAxis-tickLabel"
                            dataset={dataset}
                            margin={{ left: 50, right: 50, top: 30, bottom: 30 }}
                            xAxis={[
                                {
                                    dataKey: "time",
                                    scaleType: "point",
                                    axisLine: { stroke: "transparent" },
                                    tick: {
                                        length: 0,
                                        size: 0,
                                    },
                                },
                            ]}
                            yAxis={[
                                {
                                    axisLine: { stroke: "transparent" },
                                    tickLine: false,
                                    ticks: [0, 20, 40, 60, 80, 100],
                                    // valueFormatter: (value) => `${value.toLocaleString()}   k`,
                                },
                            ]}
                            grid={{
                                horizontal: true,
                                strokeDasharray: "5 5",
                                strokeWidth: 1,
                                stroke: "#e0e0e0",
                            }}
                            series={series}
                            height={314}

                            sx={{
                                ".MuiLineElement-root": {
                                    strokeWidth: 2,
                                },
                                ".MuiMarkElement-root": {
                                    stroke: ({ series }) => series?.color,
                                    strokeWidth: 2,
                                    scale: "1",
                                    fill: "#fff",
                                },
                                "& .MuiChartsAxis-line": {
                                    display: "none",
                                },
                                "& .MuiChartsGrid-line": {
                                    strokeDasharray: "5 5",
                                    stroke: "#e0e0e0",
                                },
                                "& .MuiChartsAxis-tick": {
                                    display: "none",
                                },
                            }}
                        />
                    </Box>
                </Box>
            </Box>
            {subTrasporto && <Box className="btnPart">
                <Button className="btn darkTheme">Sensore attivo e in registrazione</Button>
                <Button className="contentText ">Rilevazione in tempo reale</Button>
            </Box>}

        </>
    )
}

export default LineGraph